// frontend/src/components/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const ProtectedRoute = ({ roles }) => {
  const { isAuthenticated, user, loading } = useContext(AuthContext);

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-lg text-gray-700">Carregando...</div>
      </div>
    );
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/nao-autorizado" replace />;
  }

  if (user.role === 'fisioterapeuta' && user.crefitoStatus !== 'aprovado') {
    return <Navigate to="/aguardando-aprovacao" replace />;
  }

  if (user.role === 'clinica' && user.clinicaStatus !== 'aprovado') {
    return <Navigate to="/aguardando-aprovacao" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;